export default {
  'menu.projects': '项目管理',
  'menu.projects.all': '全部项目',
  'menu.projects.participated': '我参与的',
  'menu.projects.following': '我关注的',
  'menu.projects.tagManagement': '标签管理',
  'menu.estimationStandards': '工时评估标准管理',
  'menu.devAgents': '开发Agent管理',
  'menu.projectHome': '项目主页',
  'menu.projectCharter': '项目约定',
  'menu.projectCharter.projectGoals': '目标愿景',
  'menu.projectCharter.projectPrinciples': '原则要求',
  'menu.projectCharter.projectNotes': '注意事项',
  'menu.productInput': '产品输入',
  'menu.productInput.inputDashboard': '输入看板',
  'menu.productInput.issuesIdea': '想法/灵感',
  'menu.productInput.issuesRequest': '需求线索',
  'menu.productInput.referenceProducts': '参考产品',
  'menu.productInput.referenceMaterials': '资料引用',
  'menu.productInput.userFeedback': '用户反馈',
  'menu.productInput.easyRecorder': '记录易',
  'menu.requirementDefinition': '需求定义',
  'menu.requirementDefinition.summary': '概要需求',
  'menu.requirementDefinition.overviewTemplateManagement': '概要需求模板',
  'menu.requirementDefinition.featureList': '功能清单',
  'menu.requirementDefinition.roleAnalysis': '角色分析',
  'menu.requirementDefinition.conceptAnalysis': '概念分析',
  'menu.requirementDefinition.systemIntegration': '系统对接',
  'menu.requirementDefinition.document': '需求文档',
  'menu.deliveryPlanning': '交付计划',
  'menu.deliveryPlanning.issuesStory': '交付故事',
  'menu.deliveryPlanning.taskManagement': '任务管理',
  'menu.deliveryPlanning.estimationStandards': '估算标准',
  'menu.deliveryPlanning.taskListGeneration': '任务清单生成',
  'menu.developmentDesign': '研发设计',
  'menu.developmentDesign.applicationAnalysis': '应用分析',
  'menu.developmentDesign.repositoryManagement': '搭建应用',
  'menu.developmentDesign.modelingAssistant': '数据建模',
  'menu.developmentDesign.aiAssistedDesign': '原型设计',
  'menu.developmentDesign.architecture': '架构设计',
  'menu.developmentDesign.apiManagement': 'API 管理',
  'menu.developmentExecution': '研发执行',
  'menu.developmentExecution.agentManagement': 'Agent 管理',
  'menu.developmentExecution.codeRepository': '代码管理',
  'menu.developmentExecution.codeMigration': '代码迁移',
  'menu.testQuality': '测试质量',
  'menu.testQuality.testManagement': '测试管理',
  'menu.testQuality.issuesBug': '缺陷',
  'menu.testQuality.qualityAnalysis': '质量分析',
  'menu.projectAssets': '项目资产',
  'menu.projectAssets.assetLibrary': '素材库',
  'menu.projectAssets.daily-report-management': '日报管理',
  'menu.projectAssets.quote-management': '报价管理',
  'menu.projectAssets.auditLog': '审计日志',
  'menu.productionDashboard': '生产看板',
  'menu.projectDashboard': '生产看板',
  'menu.projectDashboard.dashboard': '生产看板',
  'menu.dailyManagement': '日常管理',
  'menu.dailyManagement.taskManagement': '任务管理',
  'menu.dailyManagement.communicationRecords': '沟通记录',
  'menu.dailyManagement.issueTracker': '事项管理',
  'menu.dailyManagement.issueTracker.bug': 'Bug',
  'menu.dailyManagement.issueTracker.userFeedback': '用户反馈',
  'menu.dailyManagement.issueTracker.risk': '风险',
  'menu.dailyManagement.issueTracker.problem': '问题',
  'menu.dailyManagement.issueTracker.changeRequest': '变更请求',
  'menu.dailyManagement.issueTracker.pendingConfirmation': '待确认事项',
  'menu.dailyManagement.dailyReportManagement': '日报管理',
  'menu.requirementAnalysis': '需求分析',
  'menu.requirementAnalysis.requirementPool': '需求池',
  'menu.requirementAnalysis.structuredAnalysis': '结构化分析',
  'menu.requirementAnalysis.highLevelRequirements': '概要需求',
  'menu.requirementAnalysis.featureList': '功能清单',
  'menu.requirementAnalysis.prd': '需求文档',
  'menu.prototypeDesign': '原型设计',
  'menu.prototypeDesign.brandDesign': '品牌设计',
  'menu.prototypeDesign.uiGuidelines': 'UI规范',
  'menu.prototypeDesign.informationArchitecture': '信息架构',
  'menu.prototypeDesign.menuPlanning': '菜单规划',
  'menu.prototypeDesign.pageDesign': '页面设计',
  'menu.prototypeDesign.interactionFlow': '交互流程',
  'menu.prototypeDesign.aiAssistedDesign': 'AI页面设计',
  'menu.prototypeDesign.prototypePreview': '原型预览',
  'menu.architectureDesign': '架构设计',
  'menu.architectureDesign.architectureOverview': '架构总览',
  'menu.architectureDesign.applicationArchitecture': '应用架构',
  'menu.architectureDesign.technicalStandards': '技术规范',
  'menu.architectureDesign.dataModeling': '数据建模',
  'menu.architectureDesign.apiDesign': '接口设计',
  'menu.architectureDesign.permissionModel': '权限模型',
  'menu.architectureDesign.integrationDesign': '集成设计',
  'menu.architectureDesign.adr': '架构决策',
  'menu.developmentExecution.applicationManagement': '应用管理',
  'menu.developmentExecution.developmentTasks': '开发任务',
  'menu.developmentExecution.codeManagement': '代码管理',
  'menu.developmentExecution.codeActivity': '代码活动',
  'menu.developmentExecution.buildRecords': '构建记录',
  'menu.agentsManagement': 'Agents管理',
  'menu.agentsManagement.agentWorkspace': 'Agent工作台',
  'menu.agentsManagement.projectAgents': '项目Agents',
  'menu.testingQuality': '测试质量',
  'menu.testingQuality.testingOverview': '测试概览',
  'menu.testingQuality.testPlan': '测试计划',
  'menu.testingQuality.testCases': '测试用例',
  'menu.testingQuality.testExecution': '测试执行',
  'menu.testingQuality.qualityAnalysis': '质量分析',
  'menu.testingQuality.acceptanceManagement': '验收管理',
  'menu.deploymentOperations': '部署运维',
  'menu.deploymentOperations.console': '部署控制台',
  'menu.deploymentOperations.pipelines': '流水线记录',
  'menu.deploymentOperations.runtime': '运行监控',
  'menu.deploymentOperations.coralApplicationPublication': '应用上架',
  'menu.releaseDelivery': '发布交付',
  'menu.releaseDelivery.versionManagement': '版本管理',
  'menu.releaseDelivery.releasePlan': '发布计划',
  'menu.releaseDelivery.releaseRecords': '发布记录',
  'menu.releaseDelivery.deliverablesManagement': '交付物管理',
  'menu.releaseDelivery.coralApplicationPublication': '应用上架',
  'menu.coralApplicationPublication': '应用上架',
  'menu.researchReferences': '资料研究',
  'menu.researchReferences.referenceMaterials': '参考资料',
  'menu.researchReferences.competitorManagement': '竞品管理',
  'menu.researchReferences.competitorAnalysis': '竞品分析',
  'menu.researchReferences.competitorAnalysisReport': '竞品分析报告',
  'menu.buildingAssets': '搭建辅助',
  'menu.buildingAssets.imageAssets': '图片素材',
  'menu.buildingAssets.iconAssets': '图标素材',
  'menu.projectAssets.projectDocuments': '项目文档',
  'menu.projectAssets.deliverables': '交付物',
  'menu.businessManagement': '商务管理',
  'menu.businessManagement.quotationManagement': '报价管理',
  'menu.businessManagement.contractInformation': '合同信息',
  'menu.businessManagement.paymentPlan': '回款计划',
  'menu.businessManagement.changeQuotation': '变更报价',
  'menu.projectSettings.memberManagement': '成员管理',
  'menu.projectSettings.projectDetail': '项目详情',
  'menu.projectSettings.auditLogs': '审计日志',
  'menu.projectSettings.projectAnnouncements': '项目公告',
  'menu.projectGoals': '项目约定',
  'menu.projectCollection': '项目整体',
  'menu.projectCollection.projectHome': '项目主页',
  'menu.projectCollection.projectGoals': '项目约定',
  'menu.applicationManagement': '应用管理',
  'menu.applicationManagement.repositoryManagement': '搭建应用',
  'menu.applicationManagement.applicationAnalysis': 'AI应用分析',
  'menu.application': '应用管理',
  'menu.communication': '沟通记录',
  'menu.requirements': '需求分析',
  'menu.requirements.summary': '概要需求',
  'menu.requirements.overviewTemplateManagement': '概要需求模板',
  'menu.requirements.featureList': '功能清单',
  'menu.requirements.document': '需求文档',
  'menu.requirements.roleAnalysis': '角色分析',
  'menu.requirements.conceptAnalysis': '概念分析',
  'menu.requirements.conceptAnalysis.management': '概念管理',
  'menu.requirements.conceptAnalysis.group': '概念分组',
  'menu.requirements.conceptAnalysis.relation': '概念关系',
  'menu.conceptAnalysis': '概念分析',
  'menu.conceptAnalysis.management': '概念管理',
  'menu.conceptAnalysis.group': '概念分组',
  'menu.conceptAnalysis.relation': '概念关系',
  'menu.requirements.applicationAnalysis': 'AI应用分析',
  'menu.requirements.projectGoals': '项目约定',
  'menu.dataModeling': '数据建模',
  'menu.dataModeling.modelingAssistant': 'AI辅助建模',
  'menu.dataModeling.entityManagement': '实体管理',
  'menu.dataModeling.ruleManagement': '规则管理',
  'menu.dataModeling.dataSourceManagement': '数据源管理',
  'menu.requirements.systemIntegration': '系统对接',
  'menu.prototype': '页面设计',
  'menu.architecture': '架构设计',
  'menu.architecture.overview': '概要设计',
  'menu.architecture.detail': '详细设计',
  'menu.agentManagement': 'Agent管理',
  'menu.developmentManagement': '开发管理',
  'menu.developmentManagement.agentManagement': 'Agent管理',
  // 'menu.developmentManagement.devAgentV1Planning': '任务计划编排',
  // 'menu.developmentManagement.devAgentV1': '智能体运行看板',
  // 'menu.developmentManagement.projectBlueprint': '项目蓝图',
  'menu.architecture.codeManagement': '代码管理',
  'menu.architecture.apiManagement': '接口管理',
  'menu.codeManagement': '代码管理',
  'menu.codeManagement.codeRepository': '代码仓库',
  'menu.codeManagement.codeMigration': '代码迁移',
  'menu.codeManagement.dependencyAnalysis': '依赖分析',
  'menu.apiManagement': '接口管理',
  'menu.apiManagement.apiList': '接口列表',
  'menu.apiManagement.apiQuickDebug': '接口快速调试',
  'menu.testManagement': '测试管理',
  'menu.testManagement.dashboard': '仪表盘',
  'menu.testManagement.bug': 'BUG',
  'menu.testManagement.case': '用例',
  'menu.testManagement.suite': '套件',
  'menu.testManagement.order': '测试单',
  'menu.testManagement.report': '测试报告',
  'menu.testManagement.caseLibrary': '用例库',
  'menu.qualityManagement': '质量管理',
  'menu.qualityManagement.qualityAnalysis': '质量分析',
  'menu.knowledgeBase': '资料引用',
  'menu.knowledgeBase.referenceProducts': '参考产品',
  'menu.knowledgeBase.referenceMaterials': '资料引用',
  'menu.assetLibrary': '素材库',
  'menu.projectSettings': '项目设置',
  'menu.projectSettings.projectMember': '项目与成员',
  'menu.projectSettings.projectCollaboration': '项目协同',
  'menu.projectSettings.projectAnnouncement': '项目公告',
  'menu.projectSettings.projectTags': '项目标签',
  'menu.projectSettings.developerOptions': '开发者选项',
  // ── 新导航域 ──────────────────────────────────────────────
  'menu.workbench': '工作台',
  'menu.workbenchTodo': '我的待办',
  'menu.workbenchRisk': '风险预警',
  'menu.workbenchActivity': '最近动态',
  'menu.workbenchDashboard': '经营看板',
  'menu.workbench.workbenchTodo': '我的待办',
  'menu.workbench.workbenchRisk': '风险预警',
  'menu.workbench.workbenchActivity': '最近动态',
  'menu.workbench.workbenchDashboard': '经营看板',
  'menu.customer': '客户',
  'menu.customerList': '客户库',
  'menu.customerKanban': '客户看板',
  'menu.customerKeyPerson': '关键人库',
  'menu.customerExistingSystem': '现有系统库',
  'menu.customerTag': '客户标签',
  'menu.customerMaterial': '资料归集与摘要',
  'menu.customer.customerList': '客户库',
  'menu.customer.customerKanban': '客户看板',
  'menu.customer.customerKeyPerson': '关键人库',
  'menu.customer.customerExistingSystem': '现有系统库',
  'menu.customer.customerTag': '客户标签',
  'menu.customer.customerMaterial': '资料归集与摘要',
  // Side menu labels are used directly as route names in runtime menuDataRender.
  'menu.客户看板': '客户看板',
  'menu.客户库': '客户库',
  'menu.关键人库': '关键人库',
  'menu.现有系统库': '现有系统库',
  'menu.客户标签': '客户标签',
  'menu.资料归集与摘要': '资料归集与摘要',
  'menu.solution': '方案',
  'menu.solutionList': '方案库',
  'menu.solutionTemplate': '方案模板',
  'menu.solutionQuestion': '调研题库',
  'menu.solutionCaseLibrary': '案例库',
  'menu.solutionPainPoint': '痛点库',
  'menu.solutionPlaybook': '打法库',
  'menu.solutionTalkTrack': '话术库',
  'menu.solution.solutionList': '方案库',
  'menu.solution.solutionKanban': '方案看板',
  'menu.solution.solutionQuote': '报价管理',
  'menu.solution.solutionReview': '方案评审',
  'menu.solution.solutionQuestion': '调研题库',
  'menu.solution.solutionQuestionPack': '题包管理',
  'menu.solution.solutionTemplate': '方案模板',
  'menu.delivery': '交付',
  'menu.deliveryProjectList': '项目列表',
  'menu.deliveryKanban': '项目看板',
  'menu.deliveryEstimationStandard': '估算标准',
  'menu.deliveryOverview': '交付总览',
  'menu.delivery.deliveryProject': '项目列表',
  'menu.delivery.deliveryKanban': '项目看板',
  'menu.delivery.deliveryMyTask': '我的任务',
  'menu.delivery.deliveryStageGate': '里程碑',
  'menu.delivery.deliveryRisk': '风险管理',
  'menu.delivery.deliveryResource': '资源管理',
  'menu.delivery.deliveryTemplate': '交付模板',
  'menu.delivery.deliveryModelSettings': '模型配置',
  'menu.service': '服务',
  'menu.serviceRecord': '服务记录',
  'menu.serviceSatisfaction': '满意度',
  'menu.serviceIssueTracker': '问题追踪',
  'menu.serviceHealthDashboard': '健康看板',
  'menu.service.serviceOverview': '服务总览',
  'menu.service.serviceTicket': '工单管理',
  'menu.service.serviceFeedback': '客户反馈',
  'menu.service.serviceHealth': '健康度',
  'menu.service.serviceUsage': '使用分析',
  'menu.service.serviceDemand': '二期需求',
  'menu.service.serviceRenewal': '续费增购',
  'menu.service.serviceReport': '服务报告',
  'menu.asset': '资产',
  'menu.assetMethod': '方法论库',
  'menu.assetTemplate': '模板库',
  'menu.assetMaterial': '素材库',
  'menu.assetKnowledgeBase': '知识库',
  'menu.asset.assetOverview': '资产总览',
  'menu.asset.assetMethod': '方法论库',
  'menu.asset.assetSolution': '方案资产',
  'menu.asset.assetDesign': '设计资产',
  'menu.asset.assetDevelopment': '研发资产',
  'menu.asset.assetTesting': '测试资产',
  'menu.asset.assetDelivery': '交付资产',
  'menu.asset.assetIntelligence': 'AI & Agent',
  'menu.asset.assetOperation': '运营资产',
  'menu.admin': '管理',
  'menu.adminMember': '成员管理',
  'menu.adminRole': '角色权限',
  'menu.adminTenant': '企业设置',
  'menu.adminAgent': 'Agent管理',
  'menu.adminEventEngine': '事件引擎',
  'menu.adminSecurity': '安全审计',
  'menu.admin.adminOrganization': '组织成员',
  'menu.admin.adminCustomerProjectConfig': '项目配置',
  'menu.admin.adminDictionary': '字典管理',
  'menu.admin.adminWorkflow': '流程管理',
  'menu.admin.adminPricing': '计价管理',
  'menu.admin.adminAi': 'AI 配置',
  'menu.admin.adminAgent': 'Agent管理',
  'menu.admin.adminIntegration': '集成管理',
  'menu.admin.adminEventEngine': '事件引擎',
  'menu.admin.adminSecurity': '安全审计',
  // ── 客户工作空间 ───────────────────────────────────────────
  'menu.customerWorkspaceProfile': '客户概览',
  'menu.customerWorkspaceOrganization': '组织架构',
  'menu.customerWorkspaceSystem': '现有系统',
  'menu.customerWorkspaceMaterial': '调研资料',
  'menu.customerWorkspaceSolution': '关联方案',
  'menu.customerWorkspaceProject': '关联项目',
  'menu.customerWorkspaceServiceRecord': '服务记录',
  'menu.customerWorkspaceRetrospective': '客户复盘',
  // ── 方案工作空间 ───────────────────────────────────────────
  'menu.solutionWorkspaceOverview': '方案概览',
  'menu.solutionWorkspaceDiagnosis': '诊断调研',
  'menu.solutionWorkspacePainPoint': '痛点分析',
  'menu.solutionWorkspaceProposal': '方案文档',
  'menu.solutionWorkspaceDemo': '演示资料',
  'menu.solutionWorkspaceTimeline': '推进时间线',
  'menu.solutionWorkspaceKeyPerson': '关键人',
  'menu.solutionWorkspaceCompetitor': '竞品分析',
  'menu.solutionWorkspaceFeedback': '客户反馈',
  'menu.solutionWorkspaceDecision': '决策记录',
  // ── 项目工作空间 ───────────────────────────────────────────
  'menu.projectWorkspaceOverview': '项目概览',
  'menu.projectWorkspaceRequirement': '需求',
  'menu.projectWorkspaceDelivery': '交付',
  'menu.projectWorkspaceDesign': '设计',
  'menu.projectWorkspaceDev': '研发',
  'menu.projectWorkspaceTest': '测试',
  'menu.projectWorkspaceAsset': '资产',
  // ── 方案二级菜单 ───────────────────────────────────────────
  'menu.solutionKanban': '方案看板',
  'menu.solutionQuote': '报价管理',
  'menu.solutionReview': '方案评审',
  'menu.solutionQuestionPack': '题包管理',
  // ── 交付二级菜单 ───────────────────────────────────────────
  'menu.deliveryProject': '项目列表',
  'menu.deliveryMyTask': '我的任务',
  'menu.deliveryStageGate': '里程碑',
  'menu.deliveryRisk': '风险管理',
  'menu.deliveryResource': '资源管理',
  'menu.deliveryTemplate': '交付模板',
  'menu.deliveryModelSettings': '模型配置',
  // ── 服务二级菜单 ───────────────────────────────────────────
  'menu.serviceOverview': '服务总览',
  'menu.serviceTicket': '工单管理',
  'menu.serviceFeedback': '客户反馈',
  'menu.serviceHealth': '健康度',
  'menu.serviceUsage': '使用分析',
  'menu.serviceDemand': '二期需求',
  'menu.serviceRenewal': '续费增购',
  'menu.serviceReport': '服务报告',
  // ── 资产二级菜单 ───────────────────────────────────────────
  'menu.assetOverview': '资产总览',
  'menu.assetSolution': '方案资产',
  'menu.assetDesign': '设计资产',
  'menu.assetDevelopment': '研发资产',
  'menu.assetTesting': '测试资产',
  'menu.assetDelivery': '交付资产',
  'menu.assetIntelligence': 'AI & Agent',
  'menu.assetOperation': '运营资产',
  // ── 管理二级菜单 ───────────────────────────────────────────
  'menu.adminOrganization': '组织成员',
  'menu.adminCustomerProjectConfig': '项目配置',
  'menu.adminDictionary': '字典管理',
  'menu.adminWorkflow': '流程管理',
  'menu.adminPricing': '计价管理',
  'menu.adminAi': 'AI 配置',
  'menu.adminIntegration': '集成管理',
  // ─────────────────────────────────────────────────────────
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin.sub-page': '二级管理页',
  'menu.system': '系统管理',
  'menu.system.menu': '菜单管理',
  'menu.system.user': '用户管理',
  'menu.system.role': '角色管理',
  'menu.template': '模板示例',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': '仪表盘',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.workbench': '回到工作台',
  'menu.account.tenantManagement': '企业管理',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
  'menu.auditLog': '审计日志',
  'menu.tabs.refresh': '刷新当前页签',
  'menu.tabs.closeCurrent': '关闭当前页签',
  'menu.tabs.closeOthers': '关闭其他页签',
  'menu.tabs.closeRight': '关闭右侧页签',
  'menu.tabs.closeAll': '关闭全部页签',
  'menu.tabs.scrollLeft': '向左查看页签',
  'menu.tabs.scrollRight': '向右查看页签',
  'menu.tabs.manage': '页签管理',
  'menu.tabs.unnamed': '未命名页面',
  'menu.项目管理': '项目管理',
  'menu.工时评估标准管理': '工时评估标准管理',
  'menu.开发Agent管理': '开发Agent管理',
  'menu.项目列表': '项目列表',
  'menu.项目主页': '项目主页',
  'menu.应用管理': '应用管理',
  'menu.应用管理.搭建应用': '搭建应用',
  'menu.沟通记录': '沟通记录',
  'menu.需求分析': '需求分析',
  'menu.需求分析.需求概要': '需求概要',
  'menu.需求分析.功能清单': '功能清单',
  'menu.需求分析.需求文档': '需求文档',
  'menu.页面设计': '页面设计',
  'menu.prototype.aiAssistedDesign': 'AI页面设计',
  'menu.prototype.statisticalAnalysisPageDesign': '统计分析页面设计',
  'menu.prototype.bigScreenPageDesign': '大屏页面设计',
  'menu.prototype.designManagement': '页面管理',
  'menu.prototype.themeDesign': '主题设计',
  'menu.架构设计': '架构设计',
  'menu.架构设计.概要设计': '概要设计',
  'menu.架构设计.详细设计': '详细设计',
  'menu.任务管理': '任务管理',
  'menu.缺陷管理': '缺陷管理',
  'menu.测试管理': '测试管理',
  'menu.质量管理': '质量管理',
  'menu.日报管理': '日报管理',
  'menu.报价管理': '报价管理',
  'menu.知识库': '参考资料',
  'menu.素材库': '素材库',
  'menu.审计日志': '审计日志',
  'menu.需求分析.角色分析': '角色分析',
  'menu.需求分析.概念分析': '概念分析',
  'menu.需求分析.应用分析': 'AI应用分析',
  'menu.需求分析.项目目标': '项目约定',
  'menu.需求分析.数据建模': '数据建模',
  'menu.数据建模.AI辅助建模': 'AI辅助建模',
  'menu.数据建模.实体管理': '实体管理',
  'menu.需求分析.系统对接': '系统对接',
  'menu.taskManagement': '任务管理',
  'menu.issues': '事项管理',
  'menu.issues.issuesAll': '全部',
  'menu.issues.issuesBug': '缺陷',
  'menu.issues.issuesStory': '交付故事',
  'menu.issues.issuesFeature': '新功能',
  'menu.issues.issuesImprovement': '优化改进',
  'menu.issues.issuesIdea': '想法/灵感',
  'menu.issues.issuesRequest': '需求线索',
  'menu.issues.issuesConfirmation': '待确认事项',
  'menu.issues.issuesNote': '笔记',
  'menu.daily-report-management': '日报管理',
  'menu.quote-management': '报价管理',
  'menu.customerIntelligence': '客户情报',
  'menu.customerIntelligence.customerList': '客户列表',
  'menu.solutionAdvancement': '方案推进',
  'menu.fieldResearch': '实地调研',
  'menu.fieldResearch.fieldResearchRecords': '调研记录',
  'menu.fieldResearch.fieldResearchPanel': '调研面板',
  'menu.methodologyCenter': '方法论中心',
  'menu.methodologyCenter.industryCases': '行业案例库',
  'menu.methodologyCenter.problemPainPoints': '问题与痛点库',
  'menu.methodologyCenter.commonPainPoints': '问题与痛点库',
  'menu.methodologyCenter.solutionPlaybooks': '解决方案库',
  'menu.methodologyCenter.pilotScenes': '试点场景库',
  'menu.methodologyCenter.talkTracks': '话术库',
  'menu.methodologyCenter.failureReasons': '失败原因库',
  'menu.methodologyCenter.successPlaybooks': '成功打法库',
  'menu.methodologyCenter.industryTemplates': '行业模板库',
  'menu.methodologyCenter.analysisLogics': '分析逻辑库',
  'menu.zyConsultantOperations': '顾问作战',
  'menu.zyConsultantOperations.diagnosisSessions': '诊断调查',
  'menu.zyConsultantOperations.questionBank': '题目管理',
  'menu.zyConsultantOperations.questionPacks': '题包管理',
  'menu.zyConsultantOperations.zySettings': '顾问设置',

  // ── 旧 /projects 子路由（父路由无 name，生成扁平 key）──────────
  'menu.all': '全部项目',
  'menu.participated': '我参与的',
  'menu.following': '我关注的',
  'menu.tagManagement': '标签管理',

  // ── 隐藏路由 breadcrumb key（父有 name → 生成 parent.child 格式）──
  'menu.delivery.deliveryOverview': '交付总览',

  // ── 旧 /project 子路由扁平 key ────────────────────────────────
  'menu.inputDashboard': '输入看板',
  'menu.userFeedback': '用户反馈',
  'menu.issuesAll': '全部',
  'menu.issuesBug': '缺陷',
  'menu.issuesStory': '交付故事',
  'menu.issuesFeature': '新功能',
  'menu.issuesImprovement': '优化改进',
  'menu.issuesIdea': '想法/灵感',
  'menu.issuesRequest': '需求线索',
  'menu.issuesConfirmation': '待确认事项',
  'menu.issuesNote': '笔记',
  'menu.taskListGeneration': '任务清单生成',
  'menu.summary': '概要需求',
  'menu.overviewTemplateManagement': '概要需求模板',
  'menu.featureList': '功能清单',
  'menu.roleAnalysis': '角色分析',
  'menu.systemIntegration': '系统对接',
  'menu.document': '需求文档',
  'menu.management': '概念管理',
  'menu.group': '概念分组',
  'menu.relation': '概念关系',
  'menu.applicationAnalysis': 'AI应用分析',
  'menu.repositoryManagement': '搭建应用',
  'menu.modelingAssistant': 'AI辅助建模',
  'menu.ruleManagement': '规则管理',
  'menu.dataSourceManagement': '数据源管理',
  'menu.aiAssistedDesign': 'AI页面设计',
  'menu.themeDesign': '主题设计',
  'menu.statisticalAnalysisPageDesign': '统计分析页面设计',
  'menu.bigScreenPageDesign': '大屏页面设计',
  'menu.designManagement': '页面管理',
  'menu.overview': '概要设计',
  'menu.detail': '详细设计',
  'menu.codeRepository': '代码仓库',
  'menu.codeMigration': '代码迁移',
  'menu.dependencyAnalysis': '依赖分析',
  'menu.apiList': '接口列表',
  'menu.apiQuickDebug': '接口快速调试',
  'menu.bug': 'BUG',
  'menu.case': '用例',
  'menu.suite': '套件',
  'menu.order': '测试单',
  'menu.report': '测试报告',
  'menu.caseLibrary': '用例库',
  'menu.qualityAnalysis': '质量分析',
  'menu.referenceProducts': '参考产品',
  'menu.referenceMaterials': '资料引用',
  'menu.projectMember': '项目与成员',
  'menu.projectCollaboration': '项目协同',
  'menu.projectAnnouncement': '项目公告',
  'menu.projectTags': '项目标签',
  'menu.developerOptions': '开发者选项',
};
